// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1AO9t","productName":"Table_productName__1JU9S"};